module.exports = (__webpack_require__(25))(33);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/slicer_cli_web/web_client/views/PanelGroup.js from dll-reference girder_plugin_slicer_cli_web
// module id = 128
// module chunks = 0